import { Component, Input, OnInit } from '@angular/core';
import { getThumbnail, stringSubstr } from 'src/app/utils.ts/helpers';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-tag-loader',
  templateUrl: './tag_loader.component.html',
  styleUrls: ['./tag_loader.component.scss']
})
export class TagLoaderComponent implements OnInit {
  @Input() data: any = {};
  substring= stringSubstr;
  getthumbnail = getThumbnail;
  private dominio = environment.config.backendUrl;
  imagePath: string = '';
  ngOnInit(): void {
    this.data.tag_loader_tags = this.data.tag_loader_tags.filter((tag: any) => tag.status === true);
    this.data.tag_loader_highlighted = this.data.tag_loader_highlighted.filter((highlighted: any) => highlighted.status === true);

    if(this.data.field_image?.field_media_image?.uri?.url){
      this.imagePath = `url(${this.dominio}${this.data.field_image?.field_media_image?.uri?.url})`;
    }
  }

  //Funzione usata per fare lo slice dell'array tag_related_tags perché | slice:0:5 sull'html non funziona
  cutArray(arrayToCut: any[]){
    const cutted = arrayToCut.slice(0, 5);
    return cutted;
  }
  
}
